<template>
  <embed-instructions-wrapper />
</template>

<script>
import EmbedInstructionsWrapper from '@/components/Cancellation/EmbedCode/EmbedInstructionsWrapper.vue';

export default {
  name: 'CancellationEmbedCode',
  components: { EmbedInstructionsWrapper },
};
</script>
